// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"KeySelect__spinnerWrapper--1gR9f","spinner":"KeySelect__spinner--2sJsM","keySelect":"KeySelect__keySelect--1Aecu"};